import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { useScoreStore } from '../../stores/scoreStore';

export default async function fetchScore(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void>
{
    await useScoreStore().autoFetch();
    return next();
}
